document.addEventListener('change', function(e) {
  if (e.target.classList.contains('cart-variant-edit-select')) {
    const select = e.target;
    const newVariantId = select.value;
    const oldVariantId = select.dataset.currentVariantId;
    const itemKey = select.dataset.key;
    const lineIndex = select.dataset.line;
    const quantity = parseInt(select.dataset.qty, 10) || 1;
    
    // If the user picked the exact same variant, do nothing
    if (!newVariantId || newVariantId === oldVariantId) {
      return;
    }
    
    // Disable the select to prevent multiple clicks and show loading state
    select.disabled = true;
    const container = select.closest('.cart-variant-edit-container');
    if (container) container.style.opacity = '0.4';
    
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const addUrl = (window.routes && window.routes.cart_add_url) || (rootUrl + 'cart/add.js');
    const changeUrl = (window.routes && window.routes.cart_change_url) || (rootUrl + 'cart/change.js');
    
    // 1. Add the new variant to cart
    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: newVariantId,
        quantity: quantity
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add new variant');
      }
      return response.json();
    })
    .then(() => {
      // 2. Remove the old line item using its unique line key (or line index)
      const changePayload = itemKey 
        ? { id: itemKey, quantity: 0 } 
        : { line: parseInt(lineIndex, 10) || 1, quantity: 0 };
        
      return fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(changePayload)
      });
    })
    .then(response => response.json())
    .then(cartData => {
      // 3. Trigger Dawn cart update logic
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-cart-edit', cartData: cartData });
      }
      
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      if (cartItems && typeof cartItems.onCartUpdate === 'function') {
        cartItems.onCartUpdate().finally(() => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        });
      } else {
        window.location.reload();
      }
    })
    .catch(error => {
      console.error('Error swapping cart variant:', error);
      select.disabled = false;
      if (container) container.style.opacity = '1';
      window.location.reload();
    });
  }
});

document.addEventListener('click', function(e) {
  if (e.target.closest('.cart-variant-edit-btn')) {
    e.preventDefault();
    const btn = e.target.closest('.cart-variant-edit-btn');
    const container = btn.closest('.cart-variant-edit-container');
    const textDisplay = container.querySelector('.cart-variant-edit-text');
    const selectDisplay = container.querySelector('.cart-variant-edit-select');
    
    // Toggle visibility
    if (textDisplay.style.display === 'none') {
      textDisplay.style.display = 'block';
      selectDisplay.style.display = 'none';
    } else {
      textDisplay.style.display = 'none';
      selectDisplay.style.display = 'block';
      selectDisplay.focus();
    }
  }
});
